/**
 * Computes exponential backoff delay with up to 25% random jitter.
 *
 * @param baseDelayMs - Base delay in milliseconds for attempt 0.
 * @param attempt - Zero-based attempt index (0 = first retry delay).
 * @returns Delay in milliseconds including jitter.
 * @example
 * // With baseDelayMs=500, effective delays are ~500ms, ~1000ms, ~2000ms
 * // (worst case with max jitter: ~625ms, ~1250ms, ~2500ms).
 */
export function computeBackoffDelayMs(baseDelayMs: number, attempt: number): number {
  const exponential = baseDelayMs * 2 ** attempt;
  const jitter = Math.random() * exponential * 0.25;
  return Math.round(exponential + jitter);
}
